import { render, staticRenderFns } from "./ScadenzaAttestati.vue?vue&type=template&id=9de900ac&scoped=true&"
import script from "./ScadenzaAttestati.vue?vue&type=script&lang=js&"
export * from "./ScadenzaAttestati.vue?vue&type=script&lang=js&"
import style0 from "./ScadenzaAttestati.vue?vue&type=style&index=0&id=9de900ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9de900ac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Repository/SprayerManager_WebSite/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {VBtn,VFlex,VIcon,VLayout,VTooltip})
